<template>
    <label class="form-control-radio" :class="{'radio-disabled': disabled,'radio-checked': label === value}">
        <input :value="label" type="radio" v-model="model">
        <slot></slot>
    </label>
</template>

<script>
export default {
  props: {
    value: {},
    label: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>